import { IGetBiometriaAuditoriaUseCase } from "../../../presentation/useCases/read/get_biometria_auditoria_use_case";
import { GryfoAudit } from "../../models/gryfo_audit";

import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetBiometriaAuditoriaUseCase implements IGetBiometriaAuditoriaUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async getBiometriaAuditoria(
    idGestaoDistribuicaoEpi: number, auditId?: string
  ): Promise<GryfoAudit> { 
    const response = await this.repository.getBiometriaAuditoria(idGestaoDistribuicaoEpi, auditId);
    
    return response
  }
}
